import { createContext, FC, PropsWithChildren, useMemo, useState } from 'react';
import { DocumentInstanceVersionChatContextValues } from '@app/types/document-instance/chat.ts';
import { ChatMessage } from '@app/types/chat';

const DocumentInstanceVersionChatContext =
  createContext<DocumentInstanceVersionChatContextValues | null>(null);

const DocumentInstanceVersionChatProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [activeChatId, setActiveChatId] = useState<number | null>(null);

  const defaultValues = useMemo(
    () => ({
      messages,
      setMessages,
      activeChatId,
      setActiveChatId,
    }),
    [messages, setMessages, activeChatId]
  );

  return (
    <DocumentInstanceVersionChatContext.Provider value={defaultValues}>
      {children}
    </DocumentInstanceVersionChatContext.Provider>
  );
};

export {
  DocumentInstanceVersionChatContext,
  DocumentInstanceVersionChatProvider,
};
